import {ProjectSystemType} from "../../../../model2/project/types"

export default function projectConvert_canConvertToWorkspace(projectIds: ID[]) {
    let res = true
    _.some(projectIds, (id:ID) => {
        const projectSession = gd.session.projects.get(id)
        if ([
            ProjectSystemType.PAGE,
            ProjectSystemType.EMBED,
            ProjectSystemType.LINK
        ].includes(projectSession?.systemType!)) {
            res = false
        }

        return !res
    })

    return res
}